import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  UncontrolledTooltip,
} from 'reactstrap';
import styled from 'styled-components';

const ToggleButtonToolbar = styled(ButtonToolbar).attrs({
  className: 'ml-n1 mr-n1 justify-content-center ',
})``;

const ToggleButtonGroup = styled(ButtonGroup).attrs({
  className: 'ms-1 me-1 mb-3',
})``;

const ToggleButton = styled(Button).attrs({
  color: 'darken',
})``;

const getTooltipTargetId = (group, value) => (
  `chart-controls-tooltip-target-${group}-${value}`
    .replace(/[^a-zA-Z0-9-_]/g, '-')
);

const getTooltipContentId = (group, value) => (
  `chart-controls-tooltip-content-${group}-${value}`
    .replace(/[^a-zA-Z0-9-_]/g, '-')
);

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - ChartControls component
 */
function ChartControls(props) {
  const { buttons, onButtonClick } = props;

  return (
    <ToggleButtonToolbar>
      {buttons.map(({ group, items }) => (
        <ToggleButtonGroup key={group}>
          {items.map(({
            label, value, active, disabled, disabledReason,
          }) => {
            const tooltipTargetId = getTooltipTargetId(group, value);
            const tooltipContentId = getTooltipContentId(group, value);

            return disabled && disabledReason ? (
              <React.Fragment key={value}>
                <ToggleButton
                  aria-describedby={tooltipContentId}
                  aria-disabled="true"
                  data-testid={tooltipTargetId}
                  disabled={false}
                  id={tooltipTargetId}
                  onClick={(event) => {
                    event.preventDefault();
                  }}
                >
                  {label}
                </ToggleButton>
                <UncontrolledTooltip target={tooltipTargetId} trigger="hover focus">
                  <span id={tooltipContentId}>{disabledReason}</span>
                </UncontrolledTooltip>
              </React.Fragment>
            ) : (
              <ToggleButton
                disabled={disabled}
                key={value}
                active={active}
                onClick={() => onButtonClick({ group, value })}
              >
                {label}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      ))}
    </ToggleButtonToolbar>
  );
}

ChartControls.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    group: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
      disabled: PropTypes.bool,
      disabledReason: PropTypes.node,
    })),
  })).isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

ChartControls.defaultProps = {};

export default ChartControls;
